"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  tariffs: {
    title: '滞期费费率查询',
    outboundDEM: '新海丰集装箱有限公司出口滞期费标准',
    inboundDEM: '新海丰集装箱有限公司进口滞期费标准',
    tips_1: '国内具体滞期费收费标准以当地公布为准'
  }
};